module.exports = __webpack_public_path__ + "media/11.c00f0bbf.mp3";